import React, { Component } from "react";
import { Form, Button, Message, Icon, Modal, Divider, Checkbox, Segment, Input} from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import { rendersubcomponents } from "../libs/renderFunctions";
import { Link } from "react-router-dom";
import LoadingPage from "./LoadingPage"
import DatePicker from 'react-datepicker';
import { JSONTime, JSONDate } from '../libs/sharedFunctions'


export default class SubscriptionModal extends Component {
  constructor(props) {
    super(props);
    this.state=this.defaultState;
  }
  
  defaultState={
  effectiveTo: null,
  effectiveFrom: null,
  type: 1,
  delay: 1,
  sendFrom: null,
  sendTo: null,
  includetype: 1,
  scheduledata: [],
  functiondefinition: {}, isFunctionLoaded: false, submitFailed: false, submitSuccess: false, validationErrors: [], validationWarnings: [], isExecuting: false, newid: false, authorised: true};

  loadFunction=(functionname)=>{
    //get function definition    
    invokeApig({path: "/functions/" + functionname, method: "GET",  body: null, queryParams: ['id='+this.props.parententityid]}).then((result)=>{
        
        if(result.status===200){
          console.log('result', result)
          // set field values in state
          this.setState({functiondefinition: result.data})
          this.setState({isFunctionLoaded: result.data})
          var newstate={functiondefinition: result.data, isFunctionLoaded: true};
          this.setState(newstate);

          console.log(this.props.subscriptionId, 'subscriptionId')
          if(this.props.subscriptionId)
          {
            // load data
            console.log(this.props.subscriptionData, 'subscriptiondata')
            console.log(Date(this.props.subscriptionData.effectiveto), 'datetest')
            
            var effectivefromdate=this.props.subscriptionData.effectivefrom ? new Date(this.props.subscriptionData.effectivefrom+'T00:00:00'): null;
            var effectivetodate=this.props.subscriptionData.effectiveto ? new Date(this.props.subscriptionData.effectiveto+'T00:00:00'): null;
            var sendtotime=this.props.subscriptionData.sendemailstotime ? new Date('2000-01-01T'+this.props.subscriptionData.sendemailstotime): null;
            var sendfromtime=this.props.subscriptionData.sendemailsfromtime ? new Date('2000-01-01T'+this.props.subscriptionData.sendemailsfromtime): null;
            
            console.log(sendtotime, sendfromtime, 'times')
            this.setState({effectiveTo:  effectivetodate,
              effectiveFrom:  effectivefromdate,
              type: this.props.subscriptionData.subscriptiontype,
              delay: this.props.subscriptionData.delay,
              includetype: this.props.subscriptionData.includetype,
              scheduledata: this.props.subscriptionData.groupsendtimes,
              sendTo: sendtotime,
              sendFrom: sendfromtime
            })
          
          }
          else{
            this.state.effectiveFrom=null
          }
      }
      else if(result.status===401)
      {
        console.log('result', result)
        this.setState({authorised: false, isFunctionLoaded: true, functiondefinition: result.data})
      } 
        
        });
        

  }

  async componentDidMount() {
    // this.setState(this.defaultState);
    const functionname=this.props.functionName;
    if(functionname) this.loadFunction(functionname)
      
  }

  async componentWillReceiveProps(nextProps) {

    if (nextProps.visible !== this.props.visible)
      this.setState(this.defaultState);

    if (nextProps.functionName) 
    {
      const functionname=nextProps.functionName;
      if(functionname.length>0 && this.props.parameters!==nextProps.parameters) this.loadFunction(functionname)
     
    } 
  }

executeFunction=async event => {
  if(event) event.preventDefault();
  this.setState({isExecuting: true});
  //replace parententityid parameter
  
  var parameters=this.props.parameters;
  if (!Array.isArray(parameters))
  parameters=[parameters]

  // replace other any parameters in url with values
  this.setState({submitFailed:false, submitSuccess: false, validationErrors: []});
  
  var success=true;
  var errors=[];
  var warnings=[];

  parameters.forEach(parameter=>{
    var url=this.state.functiondefinition.url.replace('{parententityid}', this.props.parententityid);
  const regexp=/\{.*?\}/
  while (regexp.test(url))
  {
      var parametername=regexp.exec(url);
      url=url.replace(parametername[0], parameter[parametername[0].slice(1,-1)]);
  }

  //create json object with form data
  var functionData={}
  // add all the data
  functionData['effectiveTo']=this.state.effectiveTo ? JSONDate(this.state.effectiveTo): this.state.effectiveTo
  functionData['effectiveFrom']=this.state.effectiveFrom ? JSONDate(this.state.effectiveFrom): this.state.effectiveFrom
  functionData['type']=this.state.type
  functionData['delay']=this.state.delay
  functionData['sendFrom']=this.state.sendFrom ? JSONTime(this.state.sendFrom): this.state.sendFrom
  functionData['sendTo']=this.state.sendTo ? JSONTime(this.state.sendTo): this.state.sendTo
  functionData['includetype']=this.state.includetype
  functionData['scheduledata']=this.state.scheduledata
  functionData['id']=this.props.subscriptionId

    invokeApig({path: url, method: "POST",  body: functionData}).then(result=>{
    console.log(result)
    if(result.status===200 || result.status===201) 
    {
        if ('warnings' in result.data)
          this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: [], validationWarnings: result.data.warnings, newid: result.data.id});
        else
          this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: []});
    }  
    else if(result.status===400) 
    {
      success=false;
      errors=result.data;
      this.setState({isExecuting: false, submitFailed:true, submitSuccess: false, validationErrors: errors});
    }
    else if(result.status===401) 
    {
    success=false;
    errors.push('You are not authorised to perform this action')
    this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
    } 
    else if(result.status===404) 
    {
      success=false;
      errors.push('API endpoint not found')
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
      } 
  
    else if(result.status===502) 
    {
      success=false;
      errors.push('An error occurred executing the request')
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
      } 
  
    else
    {
      success=false;
      errors.push('Unrecognised error code ' + result.status)
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
      } 
  }).catch(err=>
    {
      success=false;
      errors.push('An error occurred executing the request')
      this.setState({isExecuting: false, submitFailed:false, submitSuccess: true, validationErrors: errors});
    })

  })
  
}

closeButtonClicked=()=>{
  //this.resetState()
  this.setState(this.defaultState);
  this.props.closefunctionmodal(this.state.submitSuccess)

}


scheduledChange(i, value){
    var newscheduledata= this.state.scheduledata
    if (value){
      newscheduledata.push(i)
    }
    else{
      var position=newscheduledata.indexOf(i);
      newscheduledata.splice(position, 1)
    }
    this.setState({scheduledata: newscheduledata.sort(function(a, b){return a-b})})
  } 

  render() {
    return (
        this.state.authorised ?
        <Modal open={this.props.visible}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name={this.state.functiondefinition.icon}/>{this.state.functiondefinition.title}</h3>
        </Modal.Header>  
        <Modal.Content>
        {this.state.isFunctionLoaded ? 
        <Form>
          <p>Subscription Dates</p>
          <Form.Group>
          <Form.Field required>
            <label>Effective From</label>
            <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.effectiveFrom} onChange={(date) => this.setState({effectiveFrom: date})}/>
          </Form.Field>
          <Form.Field>
            <label>Effective To</label>
            <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.effectiveTo} onChange={(date) => this.setState({effectiveTo: date})}/>
          </Form.Field>
          </Form.Group>
      <p>Subscription Sending Hours</p>
      <Form.Group>
      <Form.Field required>
          <label>From</label>
          <DatePicker dateFormat="HH:mm" label='From' selected={this.state.sendFrom} onChange={(date) => this.setState({sendFrom: date})} showTimeSelect showTimeSelectOnly timeCaption="time" timeIntervals={60}/>
        </Form.Field>
        <Form.Field required>
          <label>To</label>
          <DatePicker dateFormat="HH:mm" label='To' selected={this.state.sendTo} onChange={(date) => this.setState({sendTo: date})} showTimeSelect showTimeSelectOnly timeCaption="time" timeIntervals={60}/>
        </Form.Field>
      </Form.Group>
      <p>Subscription Type</p>
      <Form.Group>
        <Checkbox label='Send On Creation' name='sendtype' value={1} checked={this.state.type === 1} onChange={(e, data)=> this.setState({type: data.value})} width={4}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='Delay Send' name='sendtype' value={2} checked={this.state.type === 2} onChange={(e, data)=> this.setState({type: data.value})} width={4}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='Group Send' name='sendtype' value={3} checked={this.state.type === 3} onChange={(e, data)=> this.setState({type: data.value})} width={4}/>&nbsp;&nbsp;&nbsp;
      </Form.Group>
      {this.state.type === 2?
      <Segment>
      <p>Delay by working hour(s)</p>
      <Form.Field>
        <Checkbox radio label='1 Hour'  name='delay' value={1} checked={this.state.delay===1} onChange={(e, data) => this.setState({delay: data.value})}/>&nbsp;&nbsp;&nbsp;
        <Checkbox radio label='2 Hours' name='delay' value={2} checked={this.state.delay===2} onChange={(e, data) => this.setState({delay: data.value})}/>&nbsp;&nbsp;&nbsp;
        <Checkbox radio label='3 Hours' name='delay' value={3} checked={this.state.delay===3} onChange={(e, data) => this.setState({delay: data.value})}/>&nbsp;&nbsp;&nbsp;
        <Checkbox radio label='4 Hours' name='delay' value={4} checked={this.state.delay===4} onChange={(e, data) => this.setState({delay: data.value})}/>&nbsp;&nbsp;&nbsp;
      </Form.Field>
      </Segment>
      : null}
      {this.state.type===3?
      <Segment>
      <p>Schedule</p>
      <Form.Field>
        <Checkbox label='8 am'  name='schedule' checked={this.state.scheduledata.includes(8)} onChange={(e, data) => this.scheduledChange(8, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='9 am'  name='schedule' checked={this.state.scheduledata.includes(9)} onChange={(e, data) => this.scheduledChange(9, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='10 am' name='schedule' checked={this.state.scheduledata.includes(10)} onChange={(e, data) => this.scheduledChange(10, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='11 am' name='schedule' checked={this.state.scheduledata.includes(11)} onChange={(e, data) => this.scheduledChange(11, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='12 pm' name='schedule' checked={this.state.scheduledata.includes(12)} onChange={(e, data) => this.scheduledChange(12, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='1 pm'  name='schedule' checked={this.state.scheduledata.includes(13)} onChange={(e, data) => this.scheduledChange(13, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='2 pm'  name='schedule' checked={this.state.scheduledata.includes(14)} onChange={(e, data) => this.scheduledChange(14, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='3 pm'  name='schedule' checked={this.state.scheduledata.includes(15)} onChange={(e, data) => this.scheduledChange(15, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='4 pm'  name='schedule' checked={this.state.scheduledata.includes(16)} onChange={(e, data) => this.scheduledChange(16, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='5 pm'  name='schedule' checked={this.state.scheduledata.includes(17)} onChange={(e, data) => this.scheduledChange(17, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='6 pm'  name='schedule' checked={this.state.scheduledata.includes(18)} onChange={(e, data) => this.scheduledChange(18, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='7 pm'  name='schedule' checked={this.state.scheduledata.includes(19)} onChange={(e, data) => this.scheduledChange(19, data.checked)}/>&nbsp;&nbsp;&nbsp;
        <Checkbox label='8 pm'  name='schedule' checked={this.state.scheduledata.includes(20)} onChange={(e, data) => this.scheduledChange(20, data.checked)}/>&nbsp;&nbsp;&nbsp;
      </Form.Field>
      </Segment>
      : null}
      <Segment>
      <p>Include</p>
      <Form.Field>
        <Checkbox radio label='All' name='all' value={1} checked={this.state.includetype === 1} onChange={(e, data) => this.setState({includetype: data.value})}/>&nbsp;&nbsp;&nbsp;
        <Checkbox radio label='Unassigned and Assigned with No Comment' name='comment' value={2} checked={this.state.includetype === 2} onChange={(e, data) => this.setState({includetype: data.value})}/>&nbsp;&nbsp;&nbsp;
        <Checkbox radio label='Unassigned' name='unassigned' value={3} checked={this.state.includetype === 3} onChange={(e, data) => this.setState({includetype: data.value})}/>&nbsp;&nbsp;&nbsp;
      </Form.Field>
      </Segment>
        <Message
          success
          visible={this.state.submitSuccess}
          header={this.state.validationWarnings.length>0 ? "Action Completed With Warnings" : "Action Completed Successfully"}
          list={this.state.validationWarnings}
          content={(this.props.functionName==='addcustomer' && this.state.newid) ? <Link to={'/view/customer/'+this.state.newid}>{'Customer Id: ' + this.state.newid}</Link>: ""}
        />
        <Message
          error
          visible={this.state.submitFailed}
          header="Action Failed"
          list={this.state.validationErrors}
        />
        <Divider/>
        <Button className="seaglassbutton" disabled={this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.executeFunction}>Save</Button>
        <Button className="seaglassbutton" onClick={this.closeButtonClicked}>Close</Button>
        </Form>
        :
        <LoadingPage/>}
        </Modal.Content>
        </Modal>
        :
        <Modal open={this.props.visible}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name={this.state.functiondefinition.icon}/>{this.state.functiondefinition.title}</h3>
        </Modal.Header>  
        <Modal.Content>
        {this.state.isFunctionLoaded ? 
        <Form>
        <Message
          warning
          visible
          header="You are not authorised to use this function, please speak to your system administrator for access."
        />
        <Divider/>
        <Button className="seaglassbutton" onClick={this.closeButtonClicked}>Close</Button>
        </Form>
        :
        <LoadingPage/>}
        </Modal.Content>
        </Modal>   
      
    );
  }
}